import { MembershipRole } from "graphql/types";

export function isEditorRole(role: MembershipRole) {
  return [MembershipRole.Admin, MembershipRole.Bookkeeper].includes(role);
}

export function isViewerRole(role: MembershipRole) {
  return [MembershipRole.Viewer].includes(role);
}
